goog.provide('el8.appchart.dialog.visitNoteTemplateEdit');

goog.require('el8.appchart.visitNote.util');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.cptCodes');
goog.require('el8.data.imos');
goog.require('el8.data.placesOfService');
goog.require('el8.data.serviceLocations');
goog.require('el8.data.visitNoteSectionNames');
goog.require('el8.template.appchart.visitNote.billDialogIcd10');
goog.require('el8.template.appchart.visitNote');
goog.require('el8.template.appshared.docTags');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.consts');

// this dialog is for editing visit note template data. it has many similarities
// the actual visit note dialog but with many parts disabled or hidden.
el8.appchart.dialog.visitNoteTemplateEdit = (function() {

    // called when visit note template saved, used to update react VNT dialog
    var _onSaveCallback = null;
    // used to export VNT - this would be supplied from react side so we don't
    // duplicate logic for exporting VNT
    var _exportVisitNoteTemplatesFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Visit Note Template',
        autoHeight: true,
        width: 610,
        position: 'center',
        showXButton: false,
        closeOnEscape: false,
        contentFn: function() {
        	return el8.template.appchart.visitNote.templateform({});
        }
    });

    var $form = $('#visit-note-template-form', that.getContentElt());
    var billingEntryTemplateFn = el8.template.appchart.visitNote.billDialogIcd10.billEntry;
    var form = new el8.uiwidget.Form({
        container: $form,

        // this multifieldListeditorSpecs is for the billing CPT codes
        multifieldListeditorSpecs: [{
            groupName: 'billEntries',
            sortable: true,
            sortUpdateFn: function() {
                that._billingLabelEntries();
            },
            listContainer: function() { return $('.billing-entry-holder', that.getContentElt()); },
            templateFn: billingEntryTemplateFn,
            fieldSpecFn: function(index) {

                var fields = [that._cptFieldSpec(index)];
                fields = fields.concat(that._modifierFieldSpecs(index));

                var $dxsContainer = $('.billing-dxs-'+index, that.getContentElt());
                fields.push({
                    name: 'dxs_'+index,
                    selector: $dxsContainer,
                    icd10ListeditorOpts: {
                        onImoSelectFn: onImoSelectFn,
                        index: index,
                        sortable: true,
                        multiple: true,
                        onAddEntry: function() { that.adjustHeight(); },
                        onRemoveEntry: function() { that.adjustHeight(); }
                    }
                });
                return fields;
            },
            getEntryMapFn: function(mle, index) {
                var map = {};
                map.cpt = mle.getVal('cpt', index);

                for (var mNum=1; mNum <= 4; mNum++) {
                    var mFieldName = 'modifier'+mNum;
                    map['modifier'+mNum] = mle.getVal(mFieldName, index);
                }

                var dxs = [];
                _.each($('.billing-icd10-line', '.billing-dxs-'+index), function(line) {
                    var icd9Ids = [];
                    _.each($('.billing-icd9', line), function(icd9elt) {
                        icd9Ids.push($(icd9elt).data('id'));
                    });
                    dxs.push({
                        icd10_code_id: $(line).data('id'),
                        icd9_code_ids: icd9Ids
                    });
                });

                map.dxs = dxs;
                map.charge = el8.util.string.cleanDecimal(mle.getVal('charge', index));
                map.units = mle.getVal('units', index);
                return map;
            },
            customInitEntryFn: function($entry, index) {
                var $dxsContainer = $('.billing-dxs-container', $entry);
                $dxsContainer.sortable({
                    handle: '.dx-sort',
                    items: '.billing-icd10-line',
                    cursor: 'move',
                    update: function(event, ui) {
                        var mle = that.getForm().getMultifieldListeditor('billEntries');
                        mle.getIcd10Listeditor('dxs', index).labelEntries();
                    },
                    forcePlaceholderSize: true, // without this drop zone targets can be too small
                    placeholder: 'el8ListItemPlaceholder', // improves drop zone visibility (optional)
                    connectWith: '.billing-dxs-container',
                    activate: function (event, ui) {
                        var mle = that.getForm().getMultifieldListeditor('billEntries');
                        var entry = mle.getEntry(index);
                        // if this section has no entries or is the sender with a lone entry
                        // (now empty) temporarily give it some height, so it can be a drop zone.
                        if (!entry.dxs.length ||
                            (this === ui.sender[0] && entry.dxs.length === 1)) {

                            var $this = $(this);
                            $this.css('height', 25);
                            $this.sortable( "refreshPositions" ); // needed to update cached height
                        }
                        mle.getAllIndexes().forEach(function(mleIndex) {
                            mle.getMindreader('cpt', mleIndex).hide();
                        });
                    },
                    deactivate: function(event, ui) {
                        $(this).css('height', '');
                    },
                    tolerance: 'pointer' // greater sensitivity works better for large elements
                });
            }
        }],
        fields: [
          {
            name: 'templateName',
            selector: ':input[name="templateName"]',
            infoText: 'template name...',
            maxLength: 50,
            validate: {
                required: true
            }
          },
          {
            name: 'billingNotes',
            selector: ':input[name="billingNotes"]',
            infoText: 'notes related to billing...',
          },
          {
            name: 'serviceLocationId',
            selector: '.billing-service-location'
          },
          {
            name: 'placeOfServiceOverride',
            selector: '.billing-place-of-service-code'
          }
        ]
    });


    var setUpButtons = function () {
        var readOnly = that.readOnly;
        form.getButtonSet().removeButtons();
        if (readOnly) {
            form.addButton('export', 'Export to Note', function () {
                that._model.parseContent();
                var hide = function() {
                    that.hide();
                };
                if (_exportVisitNoteTemplatesFn) {
                    _exportVisitNoteTemplatesFn([that._model.rawData], hide);
                } else {
                    hide();
                }
            }, true);

            form.addButton('close', 'Close', function () {
                that._model.parseContent();
                that.hide();
            }, false);
        } else {
            form.addButton('save', 'Save Template',
                function() { return that.saveTemplate(); }, true);

            // same as save, except we add a successCb that also exports the VNT
            // using _exportVisitNoteTemplatesFn, which is supplied from react side
            form.addButton('saveAndExport', 'Save & Export to Note',
                function() { return that.saveTemplate( function(item, data) {
                    if (_exportVisitNoteTemplatesFn) {
                        _exportVisitNoteTemplatesFn([data]);
                    }
                }); }, false);

            form.addDiscardChangesButton(function() {
                // ensure we backpopulate the JSON blob into all the fields
                // to wipe out any unsaved changes
                that._model.parseContent();
                that.hide();
            });
        }
    }


    that.setForm(form);

    var _appendBillingCptCode = function (cptCode) {
        var mle = form.getMultifieldListeditor('billEntries');

        var existingCpts = _.pluck(mle.getAllEntries(), 'cpt');
        if (_.contains(existingCpts, cptCode)) { return; } // duplicate

        var lastIndex = mle.getLastIndex();
        if (!mle.getVal('cpt', lastIndex)) {
            mle.setVal('cpt', lastIndex, cptCode);
        } else {
            var newIndex = mle.addNewEntry(true); // noFocus to avoid mindreader popping up
            mle.setVal('cpt', newIndex, cptCode);
        }
    };

    //////////////////////////////////////////////////////
    // Stuff Duplicated from appchart/visitNote/main.js //
    //////////////////////////////////////////////////////
    var cptMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.cptCodes(), {
        formatSelected: function(item) { return item.description; },
        selectFn: function(event, item) {
            if (el8Globals.FEATURES.AutoImportBilling) {
                var cptObj = el8.data.cptCodes.getById(item.id);
                var cptCode = cptObj.getCode();
                _appendBillingCptCode(cptCode);
            }
        }
    });

    var checklistSelectFn = function(type, item) {
        if (!that._checklists) { return; } // that = visitNote.main module
        var template = el8.data.checklistTemplates.getById(item.id);
        that._checklists[type].populateTemplate(template);
    };
    var peMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.checklistTemplates('pe'), {
        selectFn: function(event, item) { checklistSelectFn.call(this, 'pe', item); }
    });
    var rosMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.checklistTemplates('ros'), {
        selectFn: function(event, item) { checklistSelectFn.call(this, 'ros', item); }
    });

    // used by assessment and other IMO-enabled fields to also populate
    // billing section when diagnosis are selected
    var _appendBillingDiagnoses = function (dx) {
        var imo = el8.data.imos.getByKey(dx.imo_code);

        var mle = form.getMultifieldListeditor('billEntries');
        var entries = mle.getAllEntries();

        var mleIndex = entries.length ? entries.length - 1 : 0;
        var dxMaps = imo.getAsBillDxMaps();
        dxMaps.forEach(function (dxMap) {
            addBillDxEntry(dxMap, mleIndex, true);
        });
    };

    var imoMindreaderOptsFn = function(sectionName) {
        return $.extend(el8.appshared.mindreaderOpts.imosWithActiveAndRecentSignedProblems('icd10', true), {
            formatSelected: function(item) {
                if (item.model_class === 'ICD10Code') {
                    // there won't be a structured code for fallback ICD10s
                    return item.description;
                }
                // We'll use the selectFn to add a structured
                // version of any IMO results
                return '';
            },
            selectFn: function(event, item, mr, mlEntry) {
                if (item.imo_code) {
                    var imo = el8.data.imos.getLatestImoByKey(item.imo_code, item.icd10);
                    var bullet;

                    var section = that._inputSections[sectionName.toLowerCase()];
                    if (!section.isMultilist()) {
                        UIM && UIM.logError('Visit IMO section being used without multilist');
                        return;
                    }

                    // FUTURE: Allow soft-deleted IMO terms to be selected, refactor to show
                    // explicit ICD-10 codes as valid/invalid per Date of Service and Payer.
                    // Prevent soft-deleted IMO term from being selected in mindreader
                    if (!el8Globals.FEATURES.BillDxAllowInvalid && item.is_deleted) {
                        item.prop('disabled', true)
                    }

                    // Edit the existing entry, if one exists
                    if (mlEntry) {
                        var existingBulletId = mlEntry.getParentId();
                        var bulletSet = that._model.getBulletSets()[sectionName.toUpperCamel()];
                        bullet = bulletSet.getById(existingBulletId);

                        bullet.setText(item.title);
                        bullet.setImoIds([imo.getId()]);
                        section._widget.rerenderParent(mlEntry, bullet);
                        mlEntry.activateSublist();
                        mlEntry._isSaving = false;

                    // Otherwise add the new bullet, with structured codes
                    // if the user has that setting on
                    } else {
                        var bulletSpec = { 'text': item.title };
                        if (el8.data.currUser.isStructuredAssessmentsEnabled()) {
                            bulletSpec.imoIds = [imo.getId()];
                        }
                        bullet = that._model.addBullet(sectionName.toUpperCamel(), bulletSpec);
                        that._inputSections[sectionName.toLowerCase()].addEntry(bullet, false, {
                            successCb: function() {
                                var mlEntry = section._widget.getLastEntry();
                                mlEntry.activateSublist();
                            }
                        });
                    }

                    if (el8Globals.FEATURES.AutoImportBilling) {
                        _appendBillingDiagnoses(item);
                    }
                }
            },
            hideNoResults: true,
            overflowInputToLeft: true
        });
    };

    var imoAnnotationFn = function(bullet) {
        if (!bullet || !bullet.getImoIds().length) { return ''; }

        return el8.template.uiwidget.multilist.imoAnnotation({
            imos: bullet.getImoCodeObjs(true).map(el8.model.toSoyMapFn),
            isShowDualCoding: el8.data.currUser.isShowDualCodingEnabled()
        });
    };

    // NOTE: all this below is taken from the main visit note UI
    var sectionsMap = {
        'data': {
            infoText: 'data reviewed...'
        },
        'objective': {
            infoText: 'objective...'
        },
        'instr': {
            infoText: 'goals/plan for patient...'
        },
        'procedure': {
            infoText: 'procedure administered...',
            mindreaderOpts: cptMindreaderOpts
        },
        'pe': {
            infoText: 'physical exam findings...',
            mindreaderOpts: peMindreaderOpts
        },
        'ros': {
            infoText: 'review of systems...',
            mindreaderOpts: rosMindreaderOpts
        },
        'med': {
            infoText: 'meds reviewed...'
        },
        'plan': {
            infoText: 'plan...'
        },
        'test': {
            infoText: 'tests ordered...'
        },
        'tx': {
            infoText: 'treatments prescribed...'
        },
        'problem': {
            infoText: 'symptoms and HPI...',
            multilistOpts: {
                labelIfEmpty: 'Prob:'
            }
        },
        'past': {
            infoText: 'past medical history...',
            mindreaderOpts : {
                data: function() {
                    return el8.ptdata.historyItems.past.all().map(function(a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'surgical': {
            infoText: 'past surgical history...',
            mindreaderOpts : {
                data: function() {
                    return el8.ptdata.historyItems.surgical.all().map(function(a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'family': {
            infoText: 'family history...',
            mindreaderOpts : {
                data: function() {
                    return el8.ptdata.historyItems.family.all().map(function(a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'social': {
            infoText: 'social history...',
            mindreaderOpts : {
                data: function() {
                    return el8.ptdata.historyItems.social.all().map(function(a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'assessment': {
            infoText: 'assessment...',
            multilistOpts: {
                getItemAnnotationFn: imoAnnotationFn,
                mindreaderOpts: imoMindreaderOptsFn('assessment')
            }
        },
        'assessplan': {
            infoText: 'assessment/plan...',
            multilistOpts: {
                getItemAnnotationFn: imoAnnotationFn,
                mindreaderOpts: imoMindreaderOptsFn('assessplan')
            }
        },
        'reason': {
            infoText: 'reason for exam...',
            textareaOpts: {
                wrapperClass: 'el8FieldExtraLongLabelPadding',
                separator: ' '
            }
        },
        'followup': {
            infoText: 'follow up...',
            height: 2*el8.util.consts.DEFAULT_FIELD_HEIGHT,
            maxLength: 5000,
            textareaOpts: {
                wrapperClass: 'el8FieldShortLabelPadding',
                separator: ' '
            },
            mindreaderOpts: {
                data: [
                    'Follow up in 2 weeks',
                    'Follow up in 6 months',
                    'Follow up in 1 month'
                ],
                entryHeight: 25
            }
        },
        'narrative': {
            infoText: 'HPI narrative...'
        },
        'hpi': {
            infoText: 'HPI narrative...'
        },
        'allergies': {
            infoText: 'allergies...'
        },
        'habits': {
            infoText: 'habits...',
            mindreaderOpts : {
                data: function() {
                    return el8.ptdata.historyItems.habits.all().map(function(a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'dateprocedure': {
            infoText: 'date of procedure...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                separator: ' '
            }
        },
        'consultant': {
            infoText: 'name of consultant...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                separator: ' '
            }
        },
        'attending': {
            infoText: 'attending physician...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                separator: ' '
            }
        },
        'referenced': {
            sectionSelector: '#visit-note-section-referenced'
        },
        'orders': {
            sectionSelector: '#visit-note-section-orders'
        }
    };

    // NOTE: we're using class selector here instead of ID, since the DOM element IDs will have
    // collision with the visit note's own checklist
    that._addChecklist = function(type, isMinimized) {
        this._checklists[type] = new el8.appchart.visitNote.checklist({
            note: this._model,
            form: this._form,
            type: type,
            container: $('#'+type.toLowerCase()+'-detail-checklist-form', this.getContentElt()),
            checklistTrigger: $('#'+type.toLowerCase()+'-detail-checklist-trigger', this.getContentElt()),
            actionsMenu: this._actionsMenu,
            templatesTrigger: $('#'+type.toLowerCase()+'-detail-templates-trigger', this.getContentElt()),
            templatesTriggerOverrideFn: function() {
                this._form.focusField(this._type);
            },
            rightAlign: (type === 'pe'),
            sectionShowFn: function() { that._inputSections[type].show(); },
            isVisitNoteTemplate: true
        });
        if (isMinimized) {
            this._checklists[type].minimize();
        } else {
            this._checklists[type].show(false);
        }
    };

    that._addInputSection = function(name, type, isHidden) {
        if (sectionsMap[name]) {
            var opts = sectionsMap[name];
            $.extend(opts, {
                note: this._model,
                form: this._form,
                type: type,
                name: name,
                isHidden: Boolean(isHidden),
                templateClass: el8.data.visitNoteFormTemplates.getClass('twoCol.complex'),
                isVisitNoteTemplate: true
            });
            this._inputSections[name] = new el8.appchart.visitNote.section(opts).create();

            if (name === 'ros' || name === 'pe') {
                // don't minimize if hidden, so checklist displayed immediately when shown
                this._addChecklist(name, !isHidden);
            }
        }
    };

    // existing visit note functions, currently doing nothing in VNT edit, so leaving them blank
    that._addLinksSection = function(section) {};
    that._addBillingSection = function() {};

    that.saveTemplate = function(successCb) {
      var template = {};
      var inputSections = this._inputSections;
      var checklists = this._checklists;

      // doing validation
      var form = this._form;
      if (!form.getVal('templateName')) {
        el8.uiwidget.alert('Please enter a template name', null, function() {
            form.focusField('templateName');
        });
        return;
      }

      // build JSON data from bullets
      var bulletSets = this._model.getBulletSets();

      Object.keys(bulletSets).forEach(function(category) {
        var bulletSet = bulletSets[category];
        var section = inputSections[category.toLowerCase()];
        if (!section) { return; }

        var sectionType = section.getType();

        var bulletData = bulletSet.getJsonData((sectionType === 'textarea'));
        if (bulletData && bulletData.length) {
          template[category] = bulletData;
        }
      });

      // build JSON data from checklists
      var checklistSets = this._model.getChecklistSets();
      Object.keys(checklistSets).forEach(function(category) {
        var checklistSet = checklistSets[category];
        var checklist = checklists[category.toLowerCase()];
        if (!checklist) { return; }
        if (!template['checklists']) { template['checklists'] = {}; }

        var checklistData = checklist.getJsonData();
        if (checklistData || checklistData !== {}) {
          template['checklists'][category] = checklistData;
        }

        // update the checklistSet in memory w/ data we have from the form
        var checklistModel = checklistSet._all[0];
        if (checklistModel) {
            checklistModel.clearAllFields();
            Object.keys(checklistData).forEach(function(key) {
                checklistModel.setFieldByName(key,checklistData[key]);
            });
        }
      });

      // build JSON data for bills/cpts/dx
      var mle = form.getMultifieldListeditor('billEntries');
      template['billing'] = mle.getJsonData();

      template['billing_notes'] = form.getVal('billingNotes');
      template['service_location_id'] = form.getVal('serviceLocationId');
      template['place_of_service_override'] = form.getVal('placeOfServiceOverride');

      // build JSON data for doctags
      template['doc_tag_ids'] = this._model.getDocTagIds();

      // we first set the newly serialized JSON data
      this._model.setContent(JSON.stringify(template));
      // then we update the FE model to match the JSON data, to reflect any sort of
      // data sanitizing we might do here (e.g., remove empty billing CPT entries)
      this._model.parseContent();
      this._model.setName(this._form.getVal('templateName'));

      var that = this;
      el8.appservice.notifier.notify("Saving visit note template...");
      el8.data.visitNoteTemplates.saveItem(this._model, false, {
        successCb: function(item, data) {
          el8.appservice.notifier.notify("Visit note template saved.");
          that.hide();
          if (_onSaveCallback) { _onSaveCallback(); }
          if (successCb) { successCb(item, data); }
        },
        errorCb: function() {
        }
      });
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        el8.data.cptCodes.softLoad();
        el8.data.serviceLocations.softLoad(null, false);
        el8.data.placesOfService.softLoad(null, false);

        // binding triggers
        this._container.on('click', '.vitals-note-show-trigger',  function() {
          var type = $(this).attr('data-type');
          $('.'+type+'-note-section', that._container).show()
              .find(':input').focusFocus();
          $(this).closest('.vitals-wrapper').remove();
        }).on('click', '.add-billing-entry',  function(e) {
            var mle = that.getForm().getMultifieldListeditor('billEntries');
            // normally these would hide because of the click/blur, but
            // we're going to prevent that default behavior, so we do it manually
            mle.hideAllMindreaders();
            mle.addNewEntry();
            that._billingLabelEntries();
            that.adjustHeight();
            return false; // required to let the showOnFocus CPT autocomplete show up
        }).on('click', '.remove-entry-trigger',  function() {
            var index = $(this).data('index');
            var mle = that.getForm().getMultifieldListeditor('billEntries');
            var icd10LE = mle.getIcd10Listeditor('dxs', index);
            icd10LE.removeAllEntries();

            mle.removeEntry(index);
            that._billingLabelEntries();
            that.adjustHeight();

        }).on('click', '.add-edit-tags-trigger',  function() {
            var oldTagIds = that._model.getDocTagIds();
            el8.appchart.dialog.docTags.show({
                doc: that._model,
                skipSave: true,
                successCb: function(newTagIds) {
                    // we manually set the doctagids here (usually done by docTag dialog)
                    // but not in this case since we set skipSave: true
                    that._model.setDocTagIds(newTagIds);
                    that._populateDocTags();
                    that._updateBillFromTags(oldTagIds, newTagIds);
                }
           });
            return false;
        }).on('click', '.refresh-service-locations',  function() {
            el8.data.serviceLocations.load(null, false);
            that._renderServiceLocations();
        }).on('change', '.billing-service-location', function(e) {
            // When selecting a billing service location, also apply its place of service (POS) code IFF it exists
            var form = that.getForm();

            var serviceLocationId = form.getVal('serviceLocationId');
            if (!serviceLocationId) { return; }

            var selectedLocation = el8.data.serviceLocations.getById(serviceLocationId);
            if (!selectedLocation) { return; }

            var selectedPos = selectedLocation.getPlaceOfService();
            if (!selectedPos) { return; }

            form.setVal('placeOfServiceOverride', selectedPos);
        });
    };

    var super_show = that.show;
    that.show = function(spec) {

      var spec = spec || {};
      super_show.call(this);

      _onSaveCallback = spec.onSaveCallback ? spec.onSaveCallback : null;
      _exportVisitNoteTemplatesFn = spec.exportVisitNoteTemplatesFn ? spec.exportVisitNoteTemplatesFn : null;
      this._model = spec.template;
      this.readOnly = spec.readOnly || false;
      this._inputSections = {};
      this._checklists = {};
      this._vitals = {};
      this._bpCount = 0;

      var formTemplate = el8.appchart.visitNote.util.getCurrFormTemplate('twoCol.complex');
      var $form = $('#visit-note-template-form-main-section', this.getContentElt());
      $form.html(formTemplate.formTemplateFn({
        isVisitNoteTemplate: true
      }));

      // Set up collapsibility of visit note sections
      $('.section-title', $form).each(function(i, elt) {
        el8.uiwidget.collapsible({
          container: $(elt).next('.section-body'),
          triggerElt: $(elt),
          statusElt: $(elt).find('.section-status'),
          isCollapsed: false
        });
      });

      if (this.readOnly) {
          var $warningContainer = $('#visit-note-template-warnings-container');
          var readOnlyWarningTemplate = el8.template.appchart.visitNote.templateReadOnlyWarning;
          $warningContainer.html(readOnlyWarningTemplate({}));
      }

      setUpButtons();
      // Because the buttons are dynamically rendered now (rather than being instantiated
      // when the VisitNoteTemplateEdit file is executed,explicitly rendering the Forms
      // ButtonSet is required in order to display properly.
      this._form.getButtonSet().render();
      this._form.render();
      this._actionsMenu = new el8.uiwidget.NewActionsMenu({
          container: this.getContentElt(),
          anchorTop: $('#note-new-visit-content-scrollable'),
          menuId: 'visit-note-template-actions-menu'
      });

      formTemplate.showFn(this);

      // hiding vitals and the internal section, since they aren't used in VNT
      $('.vitals-container', this.getContentElt()).hide();
      $('.visit-note-internal-section', this.getContentElt()).hide();

      that._renderServiceLocations();
      that._renderPlaceOfServiceSelect();

      this._prePopulate();

      if (!this._model.getId()) {
          this._form.focusField('templateName');
      }

      // hide the MU section
      $('.el8VisitNoteMUSection', this.getContentElt()).hide();
      // hide the confidentiality section (PLR)
      $('.confidentiality-section', this.getContentElt()).hide();
      // hide patient age
      $('.sectionAgeAtVisit', this.getContentElt()).hide();

      this.adjustHeight();
      this.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(this);

        // check to see if we have a doc tag dialog open that's set to
        // be editing the tag for our current VNT, so we can close that doctag
        // dialog if it's related to our current VNT
        if (el8.appchart.dialog.docTags.isOpen()) {
            var doc = el8.appchart.dialog.docTags.getCurrentDoc();
            if (doc && this._model &&
                doc.getModelClass() === this._model.getModelClass() &&
                doc.getId() === this._model.getId()) {
                el8.appchart.dialog.docTags.hide();
            }
        }
    };

    that._prePopulate = function() {
        this._form.setVal('templateName', this._model.getName());
        this._form.setVal('billingNotes', this._model.getBillingNotes());
        this._form.setVal('serviceLocationId', this._model.getServiceLocationId() || '');
        this._form.setVal('placeOfServiceOverride', this._model.getPlaceOfServiceOverride() || '');

        el8.data.visitNoteSectionNames.forEach(function(sectionName) {
            that._populateInputSection(sectionName.toLowerCase());
        });

        // billing
        var mle = this.getForm().getMultifieldListeditor('billEntries');
        var cpts = this._model.getBillCpts();
        var billFormEntries = cpts.map(function(c) {
            var map = c.asSoyMap();
            delete map['dxs'];
            return map;
        });
        mle.populateEntries(billFormEntries);

        cpts.forEach(function(c, idx) {
            c.getDxs().forEach(function(d) {
                // noFocus to avoid mindreader popping up
                addBillDxEntry(d.asSoyMap(), idx, true);
            });
        });

        this._populateDocTags();
    };

    that._populateInputSection = function(name) {
      var items = this._model.getBulletSets()[name.capitalize()];
      if (items) { items = items.sorted(); }
      if (items && items.length) {
          this._inputSections[name].addEntries(items);
      }
      // Also check to see if there are checklists to prepopulate
      if (name === 'pe') {
          var currentPeDetail = this._model.getChecklists('Pe', this._model.getCurrentEditId()).current;
          if (currentPeDetail && !currentPeDetail.isEmpty()) {
              if (!this._checklists['pe']) { this._addInputSection('pe'); }
              this._checklists['pe'].populate(currentPeDetail, false);
              this._inputSections['pe'].show();
          }
      } else if (name === 'ros') {
          var currentRosDetail = this._model.getChecklists('Ros', this._model.getCurrentEditId()).current;
          if (currentRosDetail && !currentRosDetail.isEmpty()) {
              if (!this._checklists['ros']) { this._addInputSection('ros'); }
              this._checklists['ros'].populate(currentRosDetail, false);
              this._inputSections['ros'].show();
          }
      }
    };

    that._populateDocTags = function() {
        var docTagMaps = this._model.getDocTagMaps();
        if (docTagMaps) {
            $('.doctags', this.getContentElt()).html(
                el8.template.appshared.docTags.docTagsLine({
                    docTags: docTagMaps
                })
            );

            // el8.appshared.docTags.tooltips.create(this.getContentElt(), this._model);
        }
    };

    that._updateBillFromTags = function(oldTagIds, newTagIds) {
        var theDelta = _.difference(newTagIds, oldTagIds); // newly added stuff
        var tagsToConsider = theDelta.map(function(id) {
            return el8.data.docTags.getById(id);
        });

        var dxMaps = [];

        tagsToConsider.forEach(function(tag) {
            var code = tag.getBillingCpt();
            if (code) { _appendBillingCptCode(code); }
            var dxMap = tag.getBillingDxMap();
            if (dxMap) { dxMaps.push(dxMap); }
        });

        if (dxMaps.length) {
            var mle = form.getMultifieldListeditor('billEntries');
            var entries = mle.getAllEntries();
            var mleIndex = entries.length ? entries.length - 1 : 0;
            dxMaps.forEach(function(dxMap) {
                addBillDxEntry(dxMap, mleIndex, true);
            });
        }
    },

    // Billing Related Functions
    that._cptFieldSpec = function(index) {
        var cptMrOpts = el8.appshared.mindreaderOpts.cptCodes();

        // If invoicing is on, try to grab a CPT's default charge
        // and pull it into the form on selection
        if (el8.data.practiceSettings.isInvoicingEnabled()) {
            cptMrOpts['selectFn'] = function(event, item) {
                if (item && item.id) {
                    var cptCode = el8.data.cptCodes.getById(item.id);
                    if (cptCode.getCharge()) {
                        var mle = that.getForm().getMultifieldListeditor('billEntries');
                        mle.setVal('charge', index, cptCode.getCharge());
                    }
                }
            };
        }

        return {
            name: 'cpt_'+index,
            selector: ':input[name="cpt_'+index+'"]',
            infoText: 'CPT code',
            height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
            maxLength: 20,
            mindreaderOpts: cptMrOpts,
            newMindreader: true
        };
    };
    that._modifierFieldSpecs = function(index) {
        var fields = [];
        for (var mNum=1; mNum <= 4; mNum++) {
            var mFieldName = 'modifier'+mNum+'_'+index;
            fields.push({
                name: mFieldName,
                selector: ':input[name="'+mFieldName+'"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 2
            });
        }
        return fields;
    };
    that._billingLabelEntries = function() {
        var mle = this.getForm().getMultifieldListeditor('billEntries');
        mle.getDomEntries().each(function(index) {
            var $entry = $(this);
            $('.entry-label', $entry).text(index + 1);
        });
    };

    that._renderServiceLocations = function() {
        var serviceLocations;
        if (el8.data.currPractice.isKareoIntegrated()) {
            // only show Kareo-linked service locations to Kareo integrated users
            // because Kareo will reject all of the other service locations anyways
            serviceLocations = el8.data.serviceLocations.getKareoMappedLocations();
        } else {
            serviceLocations = el8.data.serviceLocations.sorted();
        }

        $('.billing-service-location', this.getContentElt()).html(
            el8.template.appchart.visitNote.serviceLocations({
                serviceLocations: serviceLocations.map(el8.model.toSoyMapFn),
                kareoIntegrated: el8.data.currPractice.isKareoIntegrated()
            })
        );
    };

    // Append POS code options to place of service select
    that._renderPlaceOfServiceSelect = function() {
        var placesOfService = el8.data.placesOfService.sorted();
        $('.billing-place-of-service-code', this.getContentElt()).html(
            el8.template.appchart.visitNote.placesOfServiceOptions({
                placesOfService: placesOfService.map(el8.model.toSoyMapFn)
            })
        );
    }

    function addBillDxEntry(dxMap, mleIndex, noFocus) {
        var mle = that.getForm().getMultifieldListeditor('billEntries');
        var icd10LE = mle.getIcd10Listeditor('dxs', mleIndex); // get the icd10LE for this MLE index

        // pass our showDualCoding state to the new entry
        dxMap.showDualCoding = el8.data.currUser.isShowDualCodingEnabled();
        icd10LE.addNewEntry(dxMap, noFocus);
    }

    // this is used by billing
    function onImoSelectFn(icd10Le, item, mleIndex) {
        if (item.imo_code) {
            var imo = el8.data.imos.getLatestImoByKey(item.imo_code, item.icd10);
            var dxMaps = imo.getAsBillDxMaps();
            dxMaps.forEach(function(dxMap) {
                addBillDxEntry(dxMap, mleIndex);
            });
        } else if (item.model_class === 'ICD10Code') {
            var icd10 = el8.data.icd10Codes.create(item);
            addBillDxEntry({
                icd10Code: icd10.asSoyMap()
            }, mleIndex);
        }
    }

    return that;
})();
